/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import React from 'react';
import Partners3Image from '../../../images/partners-3.png';
import Partners4Image from '../../../images/partners-4.png';
import StandardsImage from '../../../images/STANDARDS.png';
import Incubators1Image from '../../../images/INCUBATORS_1.png';
import Incubators2Image from '../../../images/INCUBATORS_2.png';
import TechPartnersImage from '../../../images/TECH_PARTNERS.png';
import EMEAImage from '../../../images/EMEA.png';
import EMEA2Image from '../../../images/EMEA2.png';
import EducationPartnersImageRow1 from '../../../images/EDUCATION_PARTNERS_1.png';
import EducationPartnersImageRow2 from '../../../images/EDUCATION_PARTNERS_2.png';


const Subtitle = (props: React.PropsWithChildren<{}>) => {
  return <h5 className='mt-4 mb-3 pb-2 border-bottom border-ThemeNeutralsLight text-ThemeTextLight'>{props.children}</h5>;
}

interface PartnerSectionSimpleProps {
  mode: 'emea' | 'asean';
}

export const PartnerSectionSimple = (props: PartnerSectionSimpleProps) => {
  const { mode } = props;

  return (
    <>
      <h3 className='mt-4'>Partners</h3>

      {mode === 'emea' ? (
        <>
          <Subtitle>EMEA</Subtitle>
          <div className='mt-6 mb-6 text-center'>
            <img src={EMEAImage} alt='EMEA Partners' />
          </div>
          <div className='mt-6 mb-6 text-center'>
            <img src={EMEA2Image} alt='EMEA Partners' />
          </div>
        </>
      ) : null}

      {mode === 'asean' ? (
        <>
          <Subtitle>ASEAN</Subtitle>
          <div className='mt-6 mb-6 text-center'>
            <img src={Partners3Image} alt='ASEAN Partners' />
          </div>
        </>
      ) : null}

      <Subtitle>EMISSIONS CALCULATORS</Subtitle>
      <div className='mt-6 mb-6 text-center'>
        <img src={Partners4Image} alt='EMISSIONS CALCULATORS Partners' />
      </div>

      <Subtitle>GLOBAL TECHNOLOGY PARTNERS</Subtitle>
      <div className='mt-6 mb-6 text-center'>
        <img src={TechPartnersImage} alt='GLOBAL TECHNOLOGY Partners' />
      </div>

      <Subtitle>FUNDRAISING & INCUBATORS</Subtitle>
      <div className='mt-6 mb-6 text-center'>
        <img src={Incubators1Image} alt='FUNDRAISING & INCUBATORS Partners' />
      </div>
      <div className='mt-6 mb-6 text-center'>
        <img src={Incubators2Image} alt='FUNDRAISING & INCUBATORS Partners' />
      </div>

      <Subtitle>EDUCATION PARTNERS</Subtitle>
      <div className='mt-6 mb-6 text-center'>
        <img src={EducationPartnersImageRow1} alt='EDUCATION PARTNERS Partners' />
        <img src={EducationPartnersImageRow2} alt='EDUCATION PARTNERS Partners' />
      </div>

      <Subtitle>STANDARD & FRAMEWORK BOARDS</Subtitle>
      <div className='mt-6 mb-6 text-center'>
        <img src={StandardsImage} alt='STANDARD & FRAMEWORK BOARDS Partners' />
      </div>
    </>
  );
}
